export const ageList = [
  {
    title: `تا ۱ سال`,
    value: "1"
  },
  {
    title: `۱ تا ۲ سال`,
    value: "2"
  },
  {
    title: `۲ تا ۳ سال`,
    value: "3"
  },
  {
    title: `۳ تا ۴ سال`,
    value: "4"
  },
  {
    title: `۴ تا ۵ سال`,
    value: "5"
  },
  {
    title: `۵ تا ۶ سال`,
    value: "6"
  },
  {
    title: `۶ تا ۷ سال`,
    value: "7"
  },
  {
    title: `۷ تا ۸ سال`,
    value: "8"
  },
  {
    title: `۸ تا ۹ سال`,
    value: "9"
  },
  {
    title: `۹ تا ۱۰ سال`,
    value: "10"
  },
  {
    title: `۱۰ تا ۱۱ سال`,
    value: "11"
  },
  {
    title: `۱۱ تا ۱۲ سال`,
    value: "12"
  }
];
